import { Dialog as MuiDialog, Grow, withStyles } from '@material-ui/core';
import React from 'react';
import Backdrop from './backdrop';

const rootWidth = 960;
const animationDuration = 600;

const Dialog = withStyles((theme) => {
  return {
    root: {},
    scrollPaper: {},
    scrollBody: {},
    container: {},
    paper: {
      margin: 0,
      width: rootWidth,
      maxWidth: 'unset',
      maxHeight: 'calc(100% - 80px)',
      borderRadius: theme.borderRadius.big,
      boxShadow: theme.shadow.modal,
    },
  };
})((props) => (
  <MuiDialog
    {...props}
    disableBackdropClick
    disableEnforceFocus
    BackdropComponent={Backdrop}
    transitionDuration={animationDuration}
    TransitionComponent={Grow}
    TransitionProps={{
      style: {
        transformOrigin: '50% 0',
      },
    }}
  />
));

export default Dialog;
